// ui/web/src/components/buzz/BuzzConnectionBadge.tsx
import type { BuzzConnectionStatus } from "@/shared/hooks/useBuzzSession"
import { cn } from "@/shared/lib/utils"

const CONFIG: Record<BuzzConnectionStatus, { label: string; dot: string }> = {
  idle:      { label: "Idle",        dot: "bg-[var(--text-02)]" },
  loading:   { label: "Connecting",  dot: "bg-[var(--status-warning-01)] animate-pulse" },
  connected: { label: "Connected",   dot: "bg-[var(--status-success-01)]" },
  error:     { label: "Error",       dot: "bg-[var(--status-error-01)]" },
}

export function BuzzConnectionBadge({ status }: { status: BuzzConnectionStatus }) {
  const cfg = CONFIG[status]
  return (
    <span className="flex items-center gap-1.5 text-xs text-[var(--text-02)]">
      <span className={cn("size-1.5 rounded-full flex-shrink-0", cfg.dot)} aria-hidden />
      {cfg.label}
    </span>
  )
}
